import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-learning-center-color-theme-picker',
  templateUrl: './learning-center-color-theme-picker.component.html',
  styleUrls: ['./learning-center-color-theme-picker.component.scss']
})
export class LearningCenterColorThemePickerComponent implements OnInit {
  @Input() learningCenterForm: FormGroup;
  @Input() learningCenterColorTheme: any[];
  themeData?= {};
  colors: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([])
  colors$ = this.colors.asObservable();
  constructor() { }

  ngOnInit(): void {

    const initialThemeId = this.learningCenterForm.get('THEME_ID').value;
    this.updateColorPalette(initialThemeId);

    this.learningCenterForm.get('THEME_ID').valueChanges.subscribe(themeId => {
      this.updateColorPalette(themeId);
    });
  }

  updateColorPalette(themeId: number): void {
    const selectedTheme = this.learningCenterColorTheme.find(theme => theme.THEME_ID === themeId);
    if (selectedTheme) {
      this.colors.next([
        selectedTheme.CONTENT2_BG,
        selectedTheme.CONTENT3_TL_TX_CL,
        selectedTheme.CONTENT3_CT_TX_CL,
        selectedTheme.CONTENT3_BG,
      ]);
    } else {
      this.colors.next([]);
    }
  }
}
